let icafeQuickViewTrigger;
let icafeQuickViewCartTransition=false;
document.addEventListener('click',function(event){
  const trigger=event.target.closest?.('button[handle][aria-controls="hdt-quick-view-modal"]');
  if(trigger)icafeQuickViewTrigger=trigger;
},true);
document.addEventListener('dialog:opening',function(event){
  if(event.target.id==='hdt-quick-view-modal')icafeQuickViewTrigger?.setAttribute('aria-expanded','true');
},true);
document.addEventListener('dialog:close',function(event){
  if(event.target.id!=='hdt-quick-view-modal')return;
  icafeQuickViewTrigger?.setAttribute('aria-expanded','false');
  if(icafeQuickViewCartTransition){icafeQuickViewCartTransition=false;return;}
  const trigger=icafeQuickViewTrigger;
  requestAnimationFrame(function(){
    const openDialogs=[...document.querySelectorAll('dialog[open]')];
    const activeDialog=openDialogs[openDialogs.length-1];
    if(trigger?.isConnected&&(!activeDialog||activeDialog.contains(trigger)))trigger.focus({preventScroll:true});
  });
},true);
document.addEventListener('cart:update',function(event){
  const dialog=event.target.closest?.('#hdt-quick-view-modal');
  if(dialog?.open&&event.detail?.source==='product-form-component'){
    icafeQuickViewCartTransition=true;
    dialog.parentElement.close(true);
  }
},true);
document.addEventListener('change',function(event){
  const picker=event.target.closest?.('#hdt-quick-view-modal hdt-variant-picker');
  if(!picker)return;
  picker.setAttribute('aria-busy','true');
  clearTimeout(picker.icafeBusyTimer);
  picker.icafeBusyTimer=setTimeout(function(){picker.removeAttribute('aria-busy');},8000);
},true);
document.addEventListener('variant:change',function(event){
  const dialog=event.target.closest?.('#hdt-quick-view-modal');
  const variant=event.detail?.variant;
  if(!dialog||!variant?.id)return;
  dialog.querySelectorAll('hdt-variant-picker[aria-busy]').forEach(function(picker){
    clearTimeout(picker.icafeBusyTimer);
    picker.removeAttribute('aria-busy');
  });
  dialog.querySelectorAll('[data-ic-qv-details]').forEach(function(link){
    const url=new URL(link.href,document.baseURI);
    url.searchParams.set('variant',String(variant.id));
    link.href=url.toString();
  });
},true);


if (!customElements.get('icafe-atelier-card')) {
  class IcafeAtelierCard extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const source = this.querySelector('[data-at-variants]');
      if (!source) return;
      try { this.variants = JSON.parse(source.textContent); } catch { return; }
      this.form = this.querySelector('form');
      this.add = this.querySelector('button[name=add]');
      this.quantity = this.querySelector('input[name=quantity]');
      this.addEventListener('change', event => {
        if (event.target.matches('[data-at-option]')) this.sync();
        if (event.target === this.quantity) this.syncQuantity();
      }, {signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-at-quantity]');
        if (!button || button.disabled) return;
        this.quantity.value = String((Number(this.quantity.value) || Number(this.quantity.min)) + Number(button.dataset.atQuantity) * Number(this.quantity.step));
        this.syncQuantity();
        this.quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }, {signal});
      this.busyObserver?.disconnect();
      this.busyObserver = new MutationObserver(() => this.syncControls());
      this.busyObserver.observe(this.add, {attributes:true,attributeFilter:['aria-busy']});
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.busyObserver?.disconnect();
    }
    selectedOptions() {
      const options = [];
      this.querySelectorAll('[data-at-option]').forEach(input => {
        if (input.type !== 'radio' || input.checked) options[Number(input.dataset.atOption)] = input.value;
      });
      return options;
    }
    sync() {
      const options = this.selectedOptions();
      const id = this.form.elements.namedItem('id');
      const variant = this.variants.find(value => options.length ? value.options.every((option, index) => option === options[index]) : String(value.id) === id.value);
      this.variant = variant;
      id.value = variant ? String(variant.id) : '';
      this.querySelector('[data-at-price]').textContent = variant?.money || '—';
      this.add.firstElementChild.textContent = !variant ? this.dataset.unavailableLabel : variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
      if (variant) {
        this.quantity.min = String(variant.min || 1);
        this.quantity.step = String(variant.step || 1);
        if (variant.max != null) this.quantity.max = String(variant.max);
        else this.quantity.removeAttribute('max');
        this.querySelectorAll('[data-pr-url]').forEach(link => {
          const url = new URL(link.href, document.baseURI);
          url.searchParams.set('variant', String(variant.id));
          link.href = url.href;
        });
      }
      this.syncQuantity();
    }
    syncQuantity() {
      const minimum = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const maximum = this.quantity.max ? Number(this.quantity.max) : Infinity;
      let value = Number(this.quantity.value);
      if (!Number.isFinite(value)) value = minimum;
      value = minimum + Math.max(0, Math.round((value - minimum) / step)) * step;
      if (value > maximum) value = minimum + Math.floor((maximum - minimum) / step) * step;
      this.quantity.value = String(Math.max(minimum, value));
      this.syncControls();
    }
    syncControls() {
      const busy = this.add.getAttribute('aria-busy') === 'true';
      this.querySelectorAll('fieldset,select[data-at-option]').forEach(input => { input.disabled = busy; });
      this.quantity.disabled = busy;
      this.add.disabled = busy || !this.variant?.available;
      this.querySelectorAll('[data-at-quantity]').forEach(button => {
        const decrease = Number(button.dataset.atQuantity) < 0;
        button.disabled = busy || (decrease ? Number(this.quantity.value) <= Number(this.quantity.min) : !!this.quantity.max && Number(this.quantity.value) >= Number(this.quantity.max));
      });
    }
  }
  customElements.define('icafe-atelier-card', IcafeAtelierCard);
}
